import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {FormControl, FormGroup} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';

@Injectable({
    providedIn: 'root'
})
export class CommonService {
    public walletOwnerCode: any;

    constructor(public router: Router, private translate: TranslateService) {
    }

    public convertDatepicker(dateObjs: any) {
        const dateObj = dateObjs['_d'];
        const month = dateObj.getMonth() + 1;
        const date = dateObj.getDate();
        const year = dateObj.getFullYear();
        return {year: year, month: month, day: date};
    }

    public convert(dateObj: { year: number; month: number; day: number }) {
        if (dateObj === null) {
            return '';
        } else if (dateObj.year !== undefined) {
            return dateObj.year.toString() + '-' + this.appendZeroIfNeeded(dateObj.month) + '-' + this.appendZeroIfNeeded(dateObj.day);
        } else {
            return '';
        }
    }

    private appendZeroIfNeeded(monthDate: number) {
        let monthDateStr: string = monthDate.toString();
        if (monthDate < 10) {
            monthDateStr = '0' + monthDate.toString();
        }
        return monthDateStr.toString();
    }

    scrollToElement(ele: string, position = 'start'): void {
        const firstElementWithError = document.querySelector(ele);
        this.scrollTo(firstElementWithError, position);
    }

    scrollTo(el: Element, position: any): void {
        if (el) {
            el.scrollIntoView({behavior: 'smooth', block: position});
        }
    }

    validateAllFields(formGroup: FormGroup) {
        Object.keys(formGroup.controls).forEach(field => {
            const control = formGroup.get(field);
            if (control instanceof FormControl) {
                control.markAsTouched({onlySelf: true});
            } else if (control instanceof FormGroup) {
                this.validateAllFields(control);
            }
        });
        return formGroup;
    }

    public languageText(key: string, callback = null) {
        let text: string;
        this.translate.get(key).subscribe(data => {
            text = data;
            if (callback) {
                callback(text);
            }
        });
        return text;
    }

}
